import React from "react"

/**
 * Standard v2 page content column. Horizontal gutters come from `.v2-page-body`
 * in the app shell (NavMainColumn); fills remaining flex space (not min-vh-100).
 *
 * @param {{
 *   className?: string,
 *   style?: React.CSSProperties,
 *   children: React.ReactNode,
 * }} props
 */
export default function V2PageContainer({
    className = "",
    style = undefined,
    children,
}) {
    return (
        <div
            className={`v2-page-content d-flex flex-column flex-grow-1 min-h-0 ${className}`.trim()}
            style={{ minWidth: 0, maxWidth: "100%", width: "100%", ...style }}
        >
            {children}
        </div>
    )
}
